export default __webpack_public_path__ + "static/media/5.53a045c1.pdf";